<template>
  <b-card class="atom-line-chart_card" no-body>
    <div class="atom-line-chart_graph">
      <div v-if="title" class="graph__title">{{ title }}</div>
      <div v-if="subTitle" class="graph__sub-title">{{ subTitle }}</div>
      <v-chart
        class="graph__echarts"
        :class="{ 'margin-top-35px': title || subTitle }"
        autoresize
        :option="option"
        ref="line"
        auto-resize
      />
    </div>
  </b-card>
</template>

<script>
import { use } from "echarts/core"

// import ECharts modules manually to reduce bundle size
import { CanvasRenderer } from "echarts/renderers"
import { LineChart } from "echarts/charts"
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components"
import VChart from "vue-echarts"

use([
  CanvasRenderer,
  LineChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
])

import { DateTime } from "luxon"
import { BCard } from "bootstrap-vue"
export default {
  name: "MoleculeConfigChangeLineChart",
  components: { BCard, VChart },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    dataset: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      timestampList: [],
      valueList: [],
      dateList: [],
      option: {},
    }
  },
  watch: {
    dataset: {
      deep: true,
      handler() {
        this.getTimestamp()
        this.getValue()
        this.initialEcharts()
      },
    },
  },
  mounted() {
    this.getTimestamp()
    this.getValue()
    this.initialEcharts()
  },
  methods: {
    getTimestamp() {
      this.timestampList = this.dataset.map((item) => {
        return this.formatTime(item.timestamp)
      })
    },
    getValue() {
      this.valueList = this.dataset.map((item) => {
        return parseFloat(item.value).toFixed(2)
      })
    },
    initialEcharts() {
      this.option = {
        grid: {
          top: "3%",
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.timestampList,
          axisLabel: {
            color: "#B9B9C3",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 20,
          axisLabel: {
            color: "#B9B9C3",
            formatter: "{value}",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: "solid",
              color: "#EBE9F1",
            },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              precision: 0,
              color: "#FFFFFF",
              backgroundColor: "#B9B9C3",
            },
          },
          backgroundColor: "#7367F0",
          padding: 10,
          formatter: (c) => {
            if (c[0].value !== "NaN")
              return `Timestamp: <b>${
                c[0].name
              }</b> <br> Configure: <b>${Math.floor(c[0].value)} Times</b>`
            return `Timestamp: <b>${c[0].name}</b> <br> ${c[0].seriesName}: <b>-</b>`
          },
          textStyle: {
            color: "#FFFFFF",
            fontFamily: "Montserrat",
          },
        },
        series: [
          {
            data: this.valueList,
            name: this.title,
            type: "line",
            showSymbol: false,
            smooth: true,
            lineStyle: {
              width: 4,
              shadowColor: "rgba(124, 123, 125, 0.270487)",
              shadowBlur: 7,
              shadowOffsetY: 16,
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#DF87F2", // color at left position
                },
                {
                  offset: 1,
                  color: "#7367F0", // color at right position
                },
              ],
            },
          },
        ],
      }
    },
    formatTime(datetime) {
      return DateTime.fromISO(datetime).toFormat("dd MMMM yyyy HH:mm")
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 0;
}

.atom-line-chart_card {
  width: 100%;
}

// graph
.atom-line-chart_graph {
  width: 100%;
}
.graph__title {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}
.graph__sub-title {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
  margin-top: 4px;
}
.graph__echarts {
  width: 100%;
  height: 240px;
}

// margin
.margin-top-35px {
  margin-top: 35px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
